import {API, graphqlOperation} from "@/plugins/finAmplifyModules"
import FinChartBuilder from "@/components/common/Chart2/FinChartBuilder"
import {indexSubscription, onUpdatePortfolioRealTimeChange} from "@/js/finSubscriptions"
import {recalculatePortfolio} from "@/components/pages/myFinHub/finPortfolios/graphql"


export function createPortfolioRealTimeSubcription(identifier, userId, useYield) {
  return {
    subscription: graphqlOperation(onUpdatePortfolioRealTimeChange, {
      id: identifier,
      owner: userId
    }),
    async trigger({data}, {chart}) {
      console.log("incoming data PFs", chart)
      const recalcPortf = data.onUpdatePortfolioRealTimeChange
      if (recalcPortf) {
        const {id} = recalcPortf
        if (id !== identifier) {
          //check if this happens and how
          return
        }

        const series = chart.get(seriesId(id))
        if (series) {
          const calcResultRequest = await API.graphql(graphqlOperation(recalculatePortfolio, {
            portfolioId: id,
            assetClass: 'TOTAL'
          }))
          const calcResult = calcResultRequest.data.getPortfolioRatioDataRealTime

          if (calcResult) {
            const point = {
              curr: calcResult.currentValue,
              x: new Date(calcResult.timestamp).getTime(),
              y: useYield ? (calcResult.yield + 100) : calcResult.result
            }

            if (chart.series?.length) {
              const {x} = point
              const {selected} = chart.rangeSelector || {}
              series.addPoint(point, false, false)
              const {min} = chart.xAxis[0].getExtremes()
              chart.xAxis[0].setExtremes(min, x, true, true, {trigger: 'addPoint'})

              if (selected !== undefined) {
                chart.rangeSelector.clickButton(selected)
              } else {
                // reselect custom button
                // (it gets lost, because the button has no type/cound definition, so that highcharts cannot select it when new data is coming in)
                const buttons = chart.rangeSelector.buttons
                buttons[buttons.length - 1].setState(2)
              }
            }
          }
        }
      }
    }
  }
}

export const COMPAREQUERIES_REALTIME = {
  SHARE: `
    query($id:ID!){
      instrument: getShare(id:$id){
          id
          mainListing{
            timeSeries {
              x:timestamp
              y:close
            }
          }
          realtime: timeSeriesRT {
            x:timestamp
            y:price
          }
      }
    }
  `,
  INDEX: `
    query($id:ID!){
      instrument: getIndex(id:$id){
          id
          mainListing{
            timeSeries {
              x:timestamp
              y:close
            }
          }
          realtime: timeSeriesRT {
            x:timestamp
            y:price
          }
      }
    }
  `,
  ETF: `
    query($id:ID!){
      instrument: getEtf(id:$id){
          id
          mainListing{
            timeSeries {
              x:timestamp
              y:close
            }
          }
          realtime: timeSeriesRT {
            x:timestamp
            y:price
          }
      }
    }
  `,
  PORTFOLIO: `
    query GetPortfolio($id: ID!) {
      getPortfolio(id: $id) {
        id
        name
        timeSeries: timeSeries(assetClass:"TOTAL"){
          y:yield
          x:timestamp
        }
        realtime: timeSeriesRT(assetClass:"TOTAL"){
          y:yield
          x:timestamp
        }
      }
    }
  `
}

export const seriesId = (id) => 'series_' + id

function getTimeseries(isPortfolio, data) {
  let timeseries
  if (isPortfolio) {
    timeseries = data.getPortfolio?.timeSeries ? [...data.getPortfolio.timeSeries, ...data.getPortfolio.realtime] : null
    timeseries.forEach(item => item.y = item.y + 100)
  } else {
    timeseries = data.instrument?.mainListing?.timeSeries ? [...data.instrument.mainListing.timeSeries, ...data.instrument?.realtime] : null
  }

  const result = FinChartBuilder.mapTimeSeriesPoint(timeseries, 'y', 'x')
  return result
}

export async function getSeries(userId, chart, selected) {
  const {data} = await API.graphql(graphqlOperation(COMPAREQUERIES_REALTIME[selected.type],
    {id: selected.item.id}))
  const isPortfolio = selected.type === 'PORTFOLIO'
  const seriesdata = getTimeseries(isPortfolio, data)
  if (!seriesdata) {
    return
  }
  const series = FinChartBuilder.createCardSelectorSeries(
    selected.item.name + (isPortfolio ? '' : ` (${selected.item.id})`), seriesdata, null)
  series.fillColor = {} //disable gradient
  series.id = seriesId(selected.item.id)
  series.color = selected.color

  if (isPortfolio) {
    const subscription = createPortfolioRealTimeSubcription(selected.item.id, userId, true)
    chart.fincraft.subscriptionManager.add(subscription.subscription, subscription.trigger, {chart})
  } else {
    chart.fincraft.subscriptionManager.add(graphqlOperation(indexSubscription, {id: selected.item.id}),
      ({data}, {chart}) => {
        console.log("incoming data !PFs", chart)
        const {price: y, timestamp} = data.onCreateRealTimePrice
        const x = (new Date(timestamp)).getTime()
        const series = chart.get(seriesId(selected.item.id))
        if (series) {
          const {selected} = chart.rangeSelector || {}
          series.addPoint([x, y], false, false)
          const {min} = chart.xAxis[0].getExtremes()
          chart.xAxis[0].setExtremes(min, x, true, true, {trigger: 'addPoint'})

          if (selected !== undefined) {
            chart.rangeSelector.clickButton(selected)
          } else {
            // reselect custom button
            // (it gets lost, because the button has no type/cound definition, so that highcharts cannot select it when new data is coming in)
            const buttons = chart.rangeSelector.buttons
            buttons[buttons.length - 1].setState(2)
          }
        }
      }, {chart}
    )
  }

  return series
}

export function selectCompareExtreme(chart) {
  const min = chart.series.reduce(function (acc, {xData: [date]}) {
    return acc > date ? acc : date
  }, undefined)

  const {max: currentMax, min: currentMin} = chart.xAxis[0].getExtremes()

  // if newExtremes === oldExtremes we have to reset them first
  // otherwise setExtremes wont trigger afterSetExtremes event
  if (min === currentMin) {
    chart.xAxis[0].setExtremes(0, 0)
  }
  chart.xAxis[0].setExtremes(min, currentMax)
  const buttons = chart.rangeSelector.buttons
  buttons[buttons.length - 1].setState(2)
}

export function updateRebaseButton(chart) {
  const showButton = chart.series.length > 1
  const buttonOptions = chart.rangeSelector.buttonOptions
  let rebaseButtonOptions = buttonOptions.find(i => i.text === 'Rebase')

  if (showButton && rebaseButtonOptions === undefined) {
    // add rebase button when displaying the second series of data
    const updatedRSButtons = [
      ...buttonOptions,
      {
        text: 'Rebase',
        type: '',
        events: {
          click: () => {
            selectCompareExtreme(chart)
            return false
          }
        }
      }]
    chart.update({
        rangeSelector: {
          buttons: updatedRSButtons
        }
      }
    )
    chart.xAxis[0].setDataGrouping({
      forced: true, units: [
        ['hour', [1]],
        ['day', [1]],
        ['week', [1]]
      ]
    })
  } else if (!showButton && rebaseButtonOptions !== undefined) {
    // remove rebase button when only one series of data is displayed
    chart.update({
        rangeSelector: {
          buttons: buttonOptions.filter(b => b.text !== 'Rebase')
        }
      }
    )
  } else {
    // reapply data grouping even though rangeSelector buttons didnt change. Mainly used after subscriptions updated
    // the chart and the custom button had to be reselected.
    const {selected} = chart.rangeSelector
    const dataGrouping = selected ? buttonOptions[selected].dataGrouping :
      {
        forced: true, units: [
          ['hour', [1]],
          ['day', [1]],
          ['week', [1]]
        ]
      }
    chart.xAxis[0].setDataGrouping(dataGrouping)

  }
}
